import React, { memo, useCallback } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingDiscountCode from 'Components/Front/Booking/BookingDiscountCode';
import BookingLegalFields from 'Components/Front/Booking/BookingLegalFields';
import BookingUserFields from 'Components/Front/Booking/BookingUserFields';
import BookingFlowStatus from 'Components/Front/Booking/BookingFlowStatus';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { num, isTrue } from 'Shared/utilities';
const {
  app
} = window;
export default memo(function CustomerBookingForm({
  ...props
}) {
  const is__free = BookingFormStore.useState(s => s.grand_total > 0 === false);
  const state_is_customer = BookingFormStore.useState(s => s.is_customer);
  const in_newsletter = BookingFormStore.useState(s => s.in_newsletter);
  const submitting = BookingFormStore.useState(s => isTrue(s.submitting));
  const redirecting = BookingFormStore.useState(s => isTrue(s.redirecting));
  const step = BookingFormStore.useState(s => s.step);
  const is__customer = state_is_customer || app.state.session.user?.roles?.includes?.('customer');
  const validate = useCallback(function (e) {
    e?.preventDefault?.();
    BookingFormStore.update(function (store) {
      store.submit_form_id = uniqid();
    });
  }, []);
  if (step !== 1 || !is__customer) return null;
  const submit_loader = submitting || redirecting ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    action: action('CreateBooking'),
    method: "POST",
    className: "c-form c-form--booking-centered",
    onSubmit: validate
  }, /*#__PURE__*/React.createElement(BookingUserFields, {
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(BookingDiscountCode, {
    space: props.space
  }), /*#__PURE__*/React.createElement(BookingLegalFields, {
    bemit: props.bemit,
    "with-newsletter": !is__customer || is__customer && !in_newsletter,
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(BookingFlowStatus, {
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary', 'round']) + ' u-block u-margin-top-25 u-margin-left-auto u-margin-right-auto',
    type: "submit"
  }, is__free ? 'Réserver' : 'Valider la réservation et procéder au paiement', submit_loader)));
});
